// import _ from "lodash";
// import { store } from "../../../store";
// import { getAbility } from "../../../reducers/sessionReducer";

const myFiSwapSuggestionTableColumns = [
  {
    name: "clientName",
    title: "Cliente",
    editable: false,
    width: 200,
  },
  // {
  //   name: "assessorName",
  //   title: "Assessor responsável",
  //   editable: false,
  //   width: 170,
  // },
  // {
  //   name: "currentAssetCode",
  //   title: "Ativo (Atual)",
  //   width: 120,
  // },
  {
    name: "currentAssetDesc",
    title: "Ativo (Atual)",
    width: 200,
  },
  {
    name: "targetAssetCode",
    title: "Ativo (Destino)",
    width: 130,
  },
  {
    name: "createdAt",
    title: "Data da Análise",
    width: 145,
    type: "date",
  },
  {
    name: "targetIssuer",
    title: "Emissor (Destino)",
    width: 150,
  },
  {
    name: "targetRateType",
    title: "Indexador",
    width: 100,
  },
  {
    name: "currentRate",
    title: "Taxa (Atual)",
    width: 120,
    type: "percentage",
  },
  {
    name: "targetRate",
    title: "Taxa (Destino)",
    width: 120,
    type: "percentage",
  },
  {
    name: "currentMaturityDate",
    title: "Vencimento (Atual)",
    width: 145,
    type: "date",
  },
  {
    name: "targetMaturityDate",
    title: "Vencimento (Destino)",
    width: 160,
    type: "date",
  },
  {
    name: "targetRating",
    title: "Rating (Destino)",
    width: 130,
  },
  // {
  //   name: "targetAvailableQuantity",
  //   title: "Qtd. Disponível",
  //   width: 125,
  // },
  {
    name: "earlyRedemptionNetValue",
    title: "Resgate Hoje",
    width: 155,
    type: "brCurrency",
  },
  {
    name: "currentPremium",
    title: "Ágio/Deságio Hoje",
    width: 155,
    type: "brCurrency",
  },
  {
    name: "projectedMaturityDate",
    title: "Vencimento (Ref)",
    width: 140,
    type: "date",
  },
  {
    name: "projectedValueIfKept",
    title: "Projeção: Manter",
    width: 155,
    type: "brCurrency",
  },
  {
    name: "projectedValueIfSwapped",
    title: "Projeção: Trocar",
    width: 150,
    type: "brCurrency",
  },
  {
    name: "netFinancialGain",
    title: "Ganho Líquido (Troca)",
    width: 160,
    type: "brCurrency",
  },
  {
    name: "grossRoa",
    title: "ROA Bruto",
    width: 100,
    type: "percentage",
  },
  {
    name: "grossRevenue",
    title: "Receita Bruta Estimada",
    width: 175,
    type: "brCurrency",
  },
  {
    name: "suggestionText",
    title: "Texto",
    width: 160,
    type: "text",
    hidden: true,
    visible: false,
  },
];

const myFiSwapSuggestionTableLeftFixedColumns = [
  "clientName",
  "currentAssetDesc",
  "targetAssetCode",
];

export { myFiSwapSuggestionTableLeftFixedColumns };
export default myFiSwapSuggestionTableColumns;
